export default __webpack_public_path__ + "static/media/games-icon.3a85fdbb.svg";